class ProductConfigurator {
  constructor(sayduckAPI) {
    this.api = sayduckAPI;
    this.configuration = this.ModifyConfigurations(
      sayduckAPI.configurator.getConfigurations()
    );
    this.activeScreen =
      this.configuration.length > 0 ? this.configuration[0] : null;
    this.firstLevelWrapper = document.getElementById(
      "configurator__swatches__first-level"
    );
    this.secondLevelWrapper = document.getElementById(
      "configurator__swatches__second-level"
    );
    this.mainProduct = null;
    this.pageCurrency = "GBP";
    this.selectedElements = {
      surfaceColor: "8e1aa220-53df-013c-c9a9-5252192a52ac",
      theme: "1296ccb0-53de-013c-448c-62df975635cc",
      themeSelection: "12971fd0-53de-013c-722c-62df975635cc",
      lineDesignAndColors: "132af200-53de-013c-ba8a-62df975635cc",
      lineDesignAndColorsSelection: "132b35e0-53de-013c-3bd3-62df975635cc",
      endToEndLines: "139f98d0-53de-013c-fcf0-62df975635cc",
      sideBars: "1397c190-53de-013c-dbd2-62df975635cc",
      reversePoints: "139ca400-53de-013c-1dd4-62df975635cc",
      topItOff: "13a1a150-53de-013c-c1fa-62df975635cc",
      fontAndColour: "liformeFont",
      fontColour: "red",
      text: "1334d630-53de-013c-abc3-62df975635cc",
      textOptionSelection: "133521a0-53de-013c-7fc6-62df975635cc",
      textSelection: "You",
    };
    this.urlSearchParams = new URLSearchParams(window.location.search);
    this.blackListedWords = localStorage.getItem("blacklisted-words");
  }

  ModifyConfigurations(configurations) {
    // Remove ground plane
    const filteredConfigurations = configurations.filter(
      (config) => config.name !== "Ground Plane"
    );

    // Remove all themes except Mandalas
    const currentThemes = configurations.filter(
      (config) => config.name === "Theme Category"
    );
    const currentThemesIndex = configurations.indexOf(currentThemes[0]);

    const themeMandala = currentThemes[0].children.filter(
      (theme) => theme.name === "Mandalas"
    );

    const validMandalas = themeMandala[0].children.filter(
      (validManadala) =>
        validManadala.name === "Classic" ||
        validManadala.name === "Cosmic Moon" ||
        validManadala.name === "Mindful Garden" ||
        validManadala.name === "Paisley" ||
        validManadala.name === "Cube" ||
        validManadala.name === "Simple Curved" ||
        validManadala.name === "Planet Earth" ||
        validManadala.name === "Geometric" ||
        validManadala.name === "Simple Straight" ||
        validManadala.name === "Love" ||
        validManadala.name === "Snowflake"
    );

    const mandalas = {
      ...themeMandala[0],
      children: [...validMandalas],
    };

    const themes = {
      ...currentThemes[0],
      children: [
        {
          ...mandalas,
        },
      ],
    };

    filteredConfigurations[currentThemesIndex] = themes;

    // Add Mantras
    const textObject = configurations.filter(
      (config) => config.name === "Text"
    );
    const textIndex = configurations.indexOf(textObject[0]);
    const currentMantrasObject = textObject[0].children.filter(
      (child) => child.name === "MANTRA & AFFIRMATIONS"
    );
    const currentMantrasIndex = textObject[0].children.indexOf(
      currentMantrasObject[0]
    );
    const mantras = [
      {
        id: "liveForMore",
        isConfiguration: false,
        name: "Live For More",
        uuid: "liveForMore",
      },
      {
        id: "liveInGoodForm",
        isConfiguration: false,
        name: "Live Life in Good Form",
        uuid: "liveInGoodForm",
      },
      //       {
      //         id: "iLoveAndAcceptMyself",
      //         isConfiguration: false,
      //         name: "I love and accept myself",
      //         uuid: "iLoveAndAcceptMyself",
      //       },
      {
        id: "iAmGrateful",
        isConfiguration: false,
        name: "I am grateful",
        uuid: "iAmGrateful",
      },
      {
        id: "iOwnMyPower",
        isConfiguration: false,
        name: "I own my power",
        uuid: "iOwnMyPower",
      },
    ];
    const newMantrasObject = {
      ...currentMantrasObject[0],
      children: mantras,
    };

    filteredConfigurations[textIndex].children[currentMantrasIndex] =
      newMantrasObject;

    // Create Font & Color
    const fontAndColor = {
      children: [
        {
          id: "liformeFont",
          isConfiguration: false,
          name: "Liforme",
          uuid: "liformeFont",
        },
        {
          id: "simpleFont",
          isConfiguration: false,
          name: "Simple",
          uuid: "simpleFont",
        },
        {
          id: "roundedFont",
          isConfiguration: false,
          name: "Rounded",
          uuid: "roundedFont",
        },
        {
          id: "handwrittenFont",
          isConfiguration: false,
          name: "Handwritten",
          uuid: "handwrittenFont",
        },
        {
          id: "rose",
          isConfiguration: false,
          name: "Rose",
          uuid: "rose",
          isIndependentSwatch: true,
        },
        {
          id: "moss",
          isConfiguration: false,
          name: "Moss",
          uuid: "moss",
          isIndependentSwatch: true,
        },
        {
          id: "sorbet",
          isConfiguration: false,
          name: "Sorbet",
          uuid: "sorbet",
          isIndependentSwatch: true,
        },
        {
          id: "lemon",
          isConfiguration: false,
          name: "Lemon",
          uuid: "lemon",
          isIndependentSwatch: true,
        },
        {
          id: "skylight",
          isConfiguration: false,
          name: "Skylight",
          uuid: "skylight",
          isIndependentSwatch: true,
        },
        {
          id: "taupe",
          isConfiguration: false,
          name: "Taupe",
          uuid: "taupe",
          isIndependentSwatch: true,
        },
        {
          id: "amethyst",
          isConfiguration: false,
          name: "Amethyst",
          uuid: "amethyst",
          isIndependentSwatch: true,
        },
        {
          id: "charcoal",
          isConfiguration: false,
          name: "Charcoal",
          uuid: "charcoal",
          isIndependentSwatch: true,
        },
        {
          id: "red",
          isConfiguration: false,
          name: "Red",
          uuid: "red",
          isIndependentSwatch: true,
        },
        {
          id: "orange",
          isConfiguration: false,
          name: "Orange",
          uuid: "orange",
          isIndependentSwatch: true,
        },
        {
          id: "yellow",
          isConfiguration: false,
          name: "Yellow",
          uuid: "yellow",
          isIndependentSwatch: true,
        },
        {
          id: "green",
          isConfiguration: false,
          name: "Green",
          uuid: "green",
          isIndependentSwatch: true,
        },
        {
          id: "blue",
          isConfiguration: false,
          name: "Blue",
          uuid: "blue",
          isIndependentSwatch: true,
        },
        {
          id: "darkBlue",
          isConfiguration: false,
          name: "Dark Blue",
          uuid: "darkBlue",
          isIndependentSwatch: true,
        },
        {
          id: "purple",
          isConfiguration: false,
          name: "Purple",
          uuid: "purple",
          isIndependentSwatch: true,
        },
      ],
      id: "fontAndColour",
      uuid: "fontAndColour",
      name: "Font and Colour",
      label: "Font & Colour",
      isConfiguration: true,
    };

    // Create Summary Page
    const summaryPage = {
      id: "summary",
      uuid: "summary",
      name: "Summary",
    };

    const newConfigurations = [
      ...filteredConfigurations,
      fontAndColor,
      summaryPage,
    ];
    return newConfigurations;
  }

  InitializeConfigurator() {
    this.BuildLoadingModal();
    const selectedElementsArray = Object.keys(this.selectedElements);
    const mapPropertyToParent = (key) => {
      switch (key) {
        case "surfaceColor":
          return {
            parentName: "Surface Color",
            level: 1,
          };
        case "sideBars":
          return {
            parentName: "45 Degree Lines",
            level: 1,
          };
        case "reversePoints":
          return {
            parentName: "Reverse Point",
            level: 1,
          };
        case "endToEndLines":
          return {
            parentName: "End to End points",
            level: 1,
          };
        case "topItOff":
          return {
            parentName: "Top It Off",
            level: 1,
          };
        case "fontAndColour":
          return {
            parentName: "Font and Colour",
            level: 1,
          };
        case "textOptionSelection":
          return {
            parentName: "Text",
            level: 2,
          };
        case "themeSelection":
          return {
            parentName: "Theme Category",
            level: 2,
          };
        case "lineDesignAndColorsSelection":
          return {
            parentName: "Line Design & Colours",
            level: 2,
          };
      }
    };

    const replaceSelectedItems = () => {
      selectedElementsArray.forEach((key) => {
        const paramExistsInURL = this.urlSearchParams.has(key);

        if (paramExistsInURL) {
          const value = this.urlSearchParams.get(key);

          const newProperties = {
            ...this.selectedElements,
            [key]: value,
          };

          this.selectedElements = newProperties;
        }
      });
    };

    const preselectItems = () => {
      selectedElementsArray.forEach((key) => {
        const parentInformation = mapPropertyToParent(key);
        if (parentInformation) {
          const { parentName, level } = parentInformation;
          const parentObject = this.configuration.filter(
            (config) => config.name === parentName
          );
          if (parentObject.length > 0) {
            const currentParent = parentObject[0];
            const currentChildrenValue = this.selectedElements[key];

            let selectedParent = null;
            let selectedChildren = null;
            if (level === 1) {
              const childrenObject = currentParent.children.filter(
                (child) => child.uuid === currentChildrenValue
              );

              if (childrenObject.length > 0) {
                const currentChildren = childrenObject[0];
                selectedParent = currentParent;
                selectedChildren = currentChildren;
              }
            } else {
              currentParent.children.forEach((child) => {
                const filtered = child.children.filter(
                  (filter) => filter.uuid === currentChildrenValue
                );
                if (filtered.length === 1) {
                  const currentFilteredElement = filtered[0];
                  selectedParent = currentParent;
                  selectedChildren = currentFilteredElement;
                }
              });
            }

            // Check type of elements
            switch (key) {
              case "surfaceColor":
              case "themeSelection":
              case "lineDesignAndColorsSelection":
              case "endToEndLines":
              case "sideBars":
              case "reversePoints":
              case "topItOff":
                if (selectedParent && selectedChildren) {
                  this.UpdateVisualizer(selectedParent, selectedChildren);
                }
                break;

              // TODO: Preload font and text
              // case "fontAndColour":
              //   const fontFamily = this.GetFontFamily(selectedChildren.uuid);
              //   if (fontFamily) {
              //     this.UpdateTextNodeAttributes({ font: fontFamily });
              //   }
              //   break;

              // case "textOptionSelection":
              //   if (selectedParent && selectedChildren) {
              //     this.UpdateVisualizer(selectedParent, selectedChildren);
              //   }
              //   const textValue = this.selectedElements.textSelection;
              //   const modifiedText = this.GetModifiedText(textValue);
              //   this.UpdateTextNode(modifiedText);
              //   this.UpdateTextNodeAttributes();

              //   break;
            }
          }
        }
      });
    };

    const getMainProduct = async () => {
      const productConfiguratorDOM = document.getElementById(
        "3d-product-configurator"
      );
      const productConfiguratorDataset = productConfiguratorDOM.dataset;
      const { productHandle } = productConfiguratorDataset;

      if (productHandle) {
        const yogaMatRequest = await fetch(`/products/${productHandle}.js`);
        const yogaMat = await yogaMatRequest.json();
        this.mainProduct = yogaMat;
      } else {
        console.error("error yoga mat!");
      }
    };

    const getPageCurrency = () => {
      const currency = window.Shopify.currency.active;
      this.pageCurrency = currency;
    };

    setTimeout(async () => {
      replaceSelectedItems();
      preselectItems();
      this.BuildActiveScreen();
      await getMainProduct();
      getPageCurrency();
    }, 200);

    setTimeout(async () => {
      await this.ChangeCameraPosition("Surface Color");
    }, 1000);
  }

  GetInnerConfiguration(parentName, level, key) {
    const parentObject = this.configuration.filter(
      (config) => config.name === parentName
    );

    if (parentObject.length === 1) {
      const currentParent = parentObject[0];
      const currentChildrenValue = this.selectedElements[key];

      let selectedParent = null;
      let selectedChildren = null;
      if (level === 1) {
        const childrenObject = currentParent.children.filter(
          (child) => child.uuid === currentChildrenValue
        );

        if (childrenObject.length > 0) {
          const currentChildren = childrenObject[0];
          selectedParent = currentParent;
          selectedChildren = currentChildren;
        }
      } else {
        currentParent.children.forEach((child) => {
          const filtered = child.children.filter(
            (filter) => filter.uuid === currentChildrenValue
          );

          if (filtered.length === 1) {
            const currentFilteredElement = filtered[0];
            selectedParent = currentParent;
            selectedChildren = currentFilteredElement;
          }
        });
      }

      return {
        selectedParent,
        selectedChildren,
      };
    }

    return null;
  }

  SetQueryParameters(property, value) {
    this.urlSearchParams.set(property, value);
    const allParams = this.urlSearchParams.toString();
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${allParams}`
    );
  }

  async ChangeCameraPosition(step) {
    const cameraAngles = await this.api.scene.getCameraUuids();
    switch (step) {
      case "Surface Color": {
        this.api.scene.setActiveCamera(cameraAngles[0]);
        break;
      }
      case "Summary":
      case "45 Degree Lines":
      case "Reverse Point":
      case "Line Design & Colours": {
        this.api.scene.setActiveCamera(cameraAngles[2]);
        break;
      }
      case "Theme Category":
      case "End to End points": {
        this.api.scene.setActiveCamera(cameraAngles[1]);
        break;
      }
      case "Top It Off": {
        this.api.scene.setActiveCamera(cameraAngles[3]);
        break;
      }
      case "Text":
      case "Font and Colour": {
        this.api.scene.setActiveCamera(cameraAngles[4]);
        break;
      }
    }
  }

  async BuildLoadingModal() {
    const modalData = window.configuratorModal;
    const modalDiv = document.getElementById("configurator-modal");

    if (modalData.enabled === "true") {
      let html = `<div class="modal-wrapper">`;

      html += `
          <button class="modal-close js-modal-close">
            <span>+</span>
          </button>
      `;

      if (modalData.title != "") {
        html += `<p class="modal-title">` + modalData.title + `</p>`;
      }
      if (modalData.body != "") {
        html += `<p class="modal-body">` + modalData.body + `</p>`;
      }
      if (modalData.continue != "" || modalData.urlText != "") {
        html += `<div class="modal-separator"></div>`;
      }
      html += `<div class="modal-buttons">`;
      if (modalData.continue != "") {
        html +=
          `<span class="modal-continue button button--tertiary js-modal-close">` +
          modalData.continue +
          `</span>`;
      }
      if (modalData.urlText != "") {
        html +=
          `<a class="modal-url button button--tertiary button-second" href="${modalData.url}"><span class="modal-url-text">` +
          modalData.urlText +
          `</span></a>`;
      }
      html += `</div>`;

      html += `</div>`;

      modalDiv.innerHTML = html;

      // Add events to close buttons

      Array.from(document.getElementsByClassName("js-modal-close")).forEach(
        (button) => {
          button.addEventListener("click", function () {
            modalDiv.classList.add("hidden");
          });
        }
      );
    }
  }

  async BuildActiveScreen() {
    const activeScreenPosition = this.configuration.indexOf(this.activeScreen);
    const isLastScreen = activeScreenPosition === this.configuration.length - 1;

    const { isConfiguration, children, name, label } = this.activeScreen;
    this.UpdateUIElements(label);

    // Change camera position
    await this.ChangeCameraPosition(name);

    if (isLastScreen) {
      await this.BuildSummaryPage();
      return;
    }

    if (isConfiguration) {
      this.BuildConfigurationLevel(children, name, 1);
      return;
    }
  }

  async BuildSummaryPage() {
    // DOM Elements
    const headingDOM = document.getElementById(
      "product-config__current-heading"
    );

    // Change title
    headingDOM.innerText = "Final Design";

    // Clear levels
    this.firstLevelWrapper.innerHTML = "";
    this.secondLevelWrapper.innerHTML = "";

    // Get Selected variant
    const selectedVariant = this.GetSelectedVariant();
    // const defaultVariant = this.mainProduct.variants.filter(
    //     (variant) => variant.title === "LYM / User selection / 3 Lines"
    // )[0];
    const defaultVariant = this.mainProduct.variants[0];
    const selectedVariantIsDefault = defaultVariant.id === selectedVariant.id;

    // Create Line properties
    const lineProperties = await this.CreateLineItems();

    // Main product information
    const { title } = this.mainProduct;
    const { option3 } = selectedVariant;
    const selectedVariantDifference = selectedVariantIsDefault
      ? 0
      : selectedVariant.price - defaultVariant.price;
    const formattedPriceDifference = Shopify.formatMoney(
      selectedVariantDifference,
      theme.moneyFormat
    );
    const formattedPrice = Shopify.formatMoney(
      defaultVariant.price,
      theme.moneyFormat
    );
    const priceDifference = `${
      selectedVariantIsDefault
        ? ""
        : ` (+ ${option3} ${formattedPriceDifference})`
    }`;

    let deliveryInfo = ``;
    if (window.strings && window.strings.delivery) {
      deliveryInfo = `<p class="product-config__delivery-message">${window.strings.delivery}</p>`;
    }

    // Build Summary UI
    const summaryUI = `
    <div class="product-config__summary">
      <h2 class="product-config__summary__title">${title}</h2>
      <p class="product-config__summary__price">${formattedPrice}${priceDifference}</p>
      <button id="product-config__add-to-cart-button" class="product-config__summary__add-to-bag button">ADD TO BAG</button>
      ${deliveryInfo}
      <button id="product-config__share-button" class="product-config__summary__share">
        <span>Share</span>
        <img src="https://cdn.shopify.com/s/files/1/0548/9645/9869/files/share_button.svg" alt="Share icon" />
      </button>
    </div>
    `;

    // Append Summary UI
    this.firstLevelWrapper.insertAdjacentHTML("beforeend", summaryUI);

    // DOM Elements - Summary UI
    const addToBagButton = document.getElementById(
      "product-config__add-to-cart-button"
    );
    const shareButton = document.getElementById("product-config__share-button");

    // Event listeners
    addToBagButton.addEventListener("click", () => {
      this.CreateCart(lineProperties, selectedVariant);
    });

    shareButton.addEventListener("click", () => {
      this.BuildShareUI();
    });
  }

  async reduce_image_file_size(base64Str, MAX_WIDTH = 450, MAX_HEIGHT = 450) {
    let resized_base64 = await new Promise((resolve) => {
      let img = new Image();
      img.src = base64Str;
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL()); // this will return base64 image results after resize
      };
    });
    return resized_base64;
  }

  async GetProductSnapshot() {
    const snapshot = await this.api.scene.requestScreenshot({
      format: "png",
      width: 800,
      height: 800,
      keepPosition: false,
      verticalAngle: 90,
      horizontalAngle: 0,
    });

    // return snapshot.dataUrl;

    return this.reduce_image_file_size(snapshot.dataUrl, 800, 800);
  }

  async CreateLineItems() {
    const selectedElementsArray = Object.keys(this.selectedElements);
    const productSnapshot = await this.GetProductSnapshot();
    const lineItems = {
      "Surface color": "",
      Theme: "",
      "Line design and colours": "",
      "End to end lines": "",
      "45 Degree Lines": "",
      "Reverse points": "",
      "Top it off": "",
      Text: "",
      "Text - User input": "",
      "Font family": "",
      "Font colour": "",
      _Image: "",
    };
    const mapLinePropertyName = (property) => {
      switch (property) {
        case "surfaceColor":
          return {
            propertyName: "Surface color",
            parentName: "Surface Color",
            level: 1,
          };
        case "themeSelection":
          return {
            propertyName: "Theme",
            parentName: "Theme Category",
            level: 2,
          };
        case "lineDesignAndColorsSelection":
          return {
            propertyName: "Line design and colours",
            parentName: "Line Design & Colours",
            level: 2,
          };
        case "endToEndLines":
          return {
            propertyName: "End to end lines",
            parentName: "End to End points",
            level: 1,
          };
        case "sideBars":
          return {
            propertyName: "45 Degree Lines",
            parentName: "45 Degree Lines",
            level: 1,
          };
        case "reversePoints":
          return {
            propertyName: "Reverse points",
            parentName: "Reverse Point",
            level: 1,
          };
        case "topItOff":
          return {
            propertyName: "Top it off",
            parentName: "Top It Off",
            level: 1,
          };
        case "fontAndColour":
          return {
            propertyName: "Font family",
            parentName: "Font and Colour",
            level: 1,
          };
        case "fontColour":
          return {
            propertyName: "Font colour",
            parentName: "Font and Colour",
            level: 1,
          };
        case "text":
          return {
            propertyName: "Text",
            parentName: "Text",
            level: 1,
          };
        case "textSelection":
          return {
            propertyName: "Text - User input",
            parentName: "Text",
            level: 2,
          };
        default:
          return null;
      }
    };

    selectedElementsArray.forEach((key) => {
      const keyProperties = mapLinePropertyName(key);

      if (keyProperties) {
        const { propertyName, parentName, level } = keyProperties;
        const propertyConfiguration = this.GetInnerConfiguration(
          parentName,
          level,
          key
        );

        if (propertyConfiguration) {
          const { selectedChildren, selectedParent } = propertyConfiguration;
          let propertyValue = "";

          if (selectedChildren) {
            const { name } = selectedChildren;
            propertyValue = name;
          } else if (key === "textSelection") {
            propertyValue = this.selectedElements[key];
          }

          if (level > 1 && selectedParent && key !== "textSelection") {
            const {
              parent: { uuid: parentUuid },
              name: childrenName,
            } = selectedChildren;
            const { children } = selectedParent;
            const filteredCategory = children.filter(
              (child) => child.uuid === parentUuid
            );

            if (filteredCategory.length === 1) {
              const { name: parentName, label: parentLabel } =
                filteredCategory[0];
              const selectedParent = parentLabel || parentName;
              propertyValue = `${selectedParent} - ${childrenName}`;
            }
          }

          if (propertyName && propertyValue) {
            lineItems[propertyName] = propertyValue;
          }
        }
      }
    });

    lineItems["_Image"] = productSnapshot;

    return lineItems;
  }

  GetSelectedVariant() {
    const getCurrentColorClass = (colorName) => {
      switch (colorName) {
        case "Blue":
          return "blue";
        case "Pink":
          return "pink";
        case "Grey":
          return "grey";
        case "Orange":
          return "orange";
        case "Purple Earth":
          return "purple";
        case "Yellow":
          return "yellow";
        case "Black":
          return "black";
        case "White":
          return "white";
        case "Maroon":
          return "maroon";
        case "Olive":
          return "olive";
          case "Aqua Teal":
          return "aqua";
        case "Red":
          return "red";
        case "Dusk Blue":
          return "dusk";
           case "Forest Green":
          return "forest";
        case "Golden Sand":
          return "sand";
        default:
          return "";
      }
    };

    const getVariantTitle = (categoryName, colorName) => {
      const color = getCurrentColorClass(colorName);
      switch (categoryName) {
        case "1 Color":
        case "2 Color":
          return `LYM / ${
            color.charAt(0).toUpperCase() + color.slice(1)
          } / 3 Lines`;
        case "3 Color":
        case "5 Color":
          return `LYM / ${
            color.charAt(0).toUpperCase() + color.slice(1)
          } / 5 Lines`;
        case "7 Colors":
          return `LYM / ${
            color.charAt(0).toUpperCase() + color.slice(1)
          } / 7 Lines`;

        default:
          return "";
      }
    };

    const getVariantDefaultTitle = (categoryName) => {
      switch (categoryName) {
        case "1 Color":
        case "2 Color":
          return `LYM / User selection / 3 Lines`;
        case "3 Color":
        case "5 Color":
          return `LYM / User selection / 5 Lines`;
        case "7 Colors":
          return `LYM / User selection / 7 Lines`;

        default:
          return "";
      }
    };

    const propertyConfiguration = this.GetInnerConfiguration(
      "Line Design & Colours",
      2,
      "lineDesignAndColorsSelection"
    );
    const surfaceColor = this.GetInnerConfiguration(
      "Surface Color",
      1,
      "surfaceColor"
    );

    const {
      selectedChildren: {
        parent: { uuid: parentUuid },
      },
      selectedParent: { children },
    } = propertyConfiguration;

    const filteredCategory = children.filter(
      (child) => child.uuid === parentUuid
    );
    if (filteredCategory.length === 1) {
      const { name: categoryName } = filteredCategory[0];

      const colorName = surfaceColor.selectedChildren.name;
      const selectedVariantTitle = getVariantTitle(categoryName, colorName);
      const filteredVariant = this.mainProduct.variants.filter(
        (variant) => variant.title === selectedVariantTitle
      );

      if (filteredVariant.length === 1) {
        return filteredVariant[0];
      } else if (filteredVariant.length === 0) {
        return this.mainProduct.variants[0];
      }

      return null;
    }

    return null;
  }

  BuildShareUI() {
    // DOM Elements
    const productConfiguratorWrapper = document.getElementById(
      "3d-product-configurator"
    );

    // Build Share UI
    const shareUI = `
    <div id="product-config__share" class="product-config__share">
		<div class="product-config__share__wrapper">
          <button id="product-config__share-button-close" class="product-config__share__close-button">
			<img alt="Close share modal icon" src="https://cdn.shopify.com/s/files/1/0548/9645/9869/files/close-button.svg?v=1634677328" />
		  </button>
          <h2 class="product-config__share__title" style="color: ${window.strings.shareDesignTitleColor};">${window.strings.shareDesignTitle}</h2>
          <p class="product-config__share__content">${window.strings.shareDesignContent}</p>
          <div class="product-config__share__social-container">
              <span class="product-config__share__social-container__title">Share to</span>
              <div class="product-config__share__social-container__icons">
                  <button id="product-config__share-email-button">
                      <img src="https://cdn.shopify.com/s/files/1/0548/9645/9869/files/envelope.svg?v=1635745095" alt="Envelop icon"/>
                  </button>
                  <button id="product-config__share-url-button">
                      <img src="https://cdn.shopify.com/s/files/1/0244/0983/3553/files/copy-link.png" alt="Link icon"/>
                  </button>
              </div>
          </div>
		  <div class="product-config__share__separator"></div>
		  <div class="product-config__share__social-container">
              <span class="product-config__share__social-container__title">Save Image</span>
              <div class="product-config__share__social-container__icons-no-background">
                  <button id="product-config__save-image-button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <mask id="mask0_1026:3813" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                      <path d="M17 11.4286L17 15.7619C17 16.3142 16.5523 16.7619 16 16.7619L2 16.7619C1.44771 16.7619 1 16.3142 1 15.7619L1 11.4286" stroke="#504F60" stroke-width="1.5"/>
                      <path d="M8.08869 13.4827C8.38158 13.7756 8.85646 13.7756 9.14935 13.4827L13.9223 8.70974C14.2152 8.41685 14.2152 7.94197 13.9223 7.64908C13.6294 7.35619 13.1546 7.35619 12.8617 7.64908L8.61902 11.8917L4.37638 7.64908C4.08348 7.35619 3.60861 7.35619 3.31572 7.64908C3.02282 7.94197 3.02282 8.41685 3.31572 8.70974L8.08869 13.4827ZM7.86902 0L7.86902 12.9524H9.36902V0L7.86902 0Z" fill="#504F60"/>
                      </mask>
                      <g mask="url(#mask0_1026:3813)">
                      <rect x="-1.0564" y="-1.29449" width="20.0651" height="20.0651" fill="#504e60"/>
                      </g>
                    </svg>
                  </button>
              </div>
          </div>
		</div>
    </div>
    `;

    // Append Summary UI
    productConfiguratorWrapper.insertAdjacentHTML("beforeend", shareUI);

    // DOM Elements - Share UI
    const shareUIContainer = document.getElementById("product-config__share");
    const shareUICloseButton = document.getElementById(
      "product-config__share-button-close"
    );
    const shareUIUrlButton = document.getElementById(
      "product-config__share-url-button"
    );
    const shareUIEmailButton = document.getElementById(
      "product-config__share-email-button"
    );
    const saveImageButton = document.getElementById(
      "product-config__save-image-button"
    );
    const shareAllButton = document.getElementById(
      "product-config__share-all-button"
    );

    // Event Handlers
    const closeShareModal = () => {
      shareUIContainer.remove();
    };

    const copyShareURL = async () => {
      const text = window.location;
      // TODO: Build notification
      await navigator.clipboard.writeText(text);
      this.ShowToast("URL Copied");
    };

    const sendEmail = () => {
      const text = window.location;
      window.open(
        `mailto:?subject=Custom Yoga Mats from Liforme!&body=${text}`
      );
    };

    const saveImage = () => {
      this.api.scene.takePhoto({
        format: "png",
        keepPosition: false,
        noCrop: false,
      });
      this.ShowToast("Image saved");
    };

    const shareAll = () => {
      if (navigator.share) {
        navigator
          .share({
            title: "LIFORME X YOU",
            url: window.location.href,
          })
          .then(() => {
            console.info("Thanks for sharing!");
          })
          .catch(console.error);
      } else {
        // TODO: Show fallback
      }
    };

    // Event Listeners
    shareUICloseButton.addEventListener("click", closeShareModal);
    shareUIUrlButton.addEventListener("click", copyShareURL);
    shareUIEmailButton.addEventListener("click", sendEmail);
    saveImageButton.addEventListener("click", saveImage);
    shareAllButton.addEventListener("click", shareAll);
  }

  ShowToast(text) {
    Toastify({
      text,
      duration: 4000,
      close: true,
      gravity: "bottom",
      position: "center",
      stopOnFocus: false,
      style: {
        background: "#ea5c8e",
        color: "white",
        fontFamily: '"Proxima Nova W05 Semibold",helvetica,arial,sans-serif',
        textTransform: "uppercase",
        padding: "12px 32px",
        borderRadius: "30px",
      },
      onClick: function () {},
    }).showToast();
  }

  CreateCart(lineProperties, selectedVariant) {
    const redirectToCart = () => {
      const path = window.location.origin + window.routes.root_url;
      const newLocation = `${path}/cart`;

      window.location = newLocation;
    };

    const addToCart = async () => {
      const { id } = selectedVariant;

      const formData = {
        items: [
          {
            id,
            quantity: 1,
            properties: lineProperties,
          },
        ],
      };

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const cart = await response.json();

        if (cart.items) {
          redirectToCart();
        } else {
          alert(cart.description);
        }
      } catch (error) {
        alert(error.description);
      }
    };

    const initializeCartActions = async () => {
      // await clearCart();
      await addToCart();
    };

    initializeCartActions();
  }

  UpdateUIElements(label) {
    // DOM Elements
    const nextButtonDOM = document.getElementById(
      "product-config__next-button"
    );
    const headingDOM = document.getElementById(
      "product-config__current-heading"
    );
    const stepDOM = document.getElementById("product-config__current-step");
    const progressBarWrapperDOM = document.getElementById(
      "configurator__progress-bar"
    );
    const progressBarDOM = document.getElementById(
      "configurator__progress-bar__bar"
    );

    const currentIndex = this.configuration.indexOf(this.activeScreen);
    const currentPosition = currentIndex + 1;
    const totalSteps = this.configuration.length;

    // Change title and progress
    headingDOM.innerText = label;
    stepDOM.innerText = `${currentPosition}/${totalSteps}`;

    // Move progress bar
    const progressBarWrapperWidth = progressBarWrapperDOM.offsetWidth;
    const progressBarWidth = progressBarWrapperWidth / totalSteps;
    const progressBarDistance = currentIndex * progressBarWidth;
    const activeScreenPosition = this.configuration.indexOf(this.activeScreen);
    const isLastScreen = activeScreenPosition === this.configuration.length - 1;

    progressBarDOM.style.width = `${progressBarWidth}px`;

    anime({
      targets: progressBarDOM,
      translateX: progressBarDistance,
      easing: "easeInOutQuad",
      duration: 200,
    });

    // Empty swatches containers
    this.firstLevelWrapper.innerHTML = "";
    this.secondLevelWrapper.innerHTML = "";

    // Hide or show arrows
    const backButtonDOM = document.getElementById(
      "product-config__back-button"
    );
    if (currentIndex === 0) {
      anime({
        targets: progressBarDOM,
        easing: "easeInOutQuad",
        borderRadius: "0 5px 5px 0",
        duration: 200,
      });
      anime({
        targets: backButtonDOM,
        easing: "easeInOutQuad",
        opacity: 0,
        duration: 200,
        cursor: "auto",
      });
    } else {
      anime({
        targets: progressBarDOM,
        easing: "easeInOutQuad",
        borderRadius: "5px",
        duration: 200,
      });
      anime({
        targets: backButtonDOM,
        easing: "easeInOutQuad",
        opacity: 1,
        duration: 200,
        cursor: "pointer",
      });
    }

    if (isLastScreen) {
      anime({
        targets: nextButtonDOM,
        easing: "easeInOutQuad",
        opacity: 0,
        duration: 200,
        cursor: "auto",
      });
    } else {
      anime({
        targets: nextButtonDOM,
        easing: "easeInOutQuad",
        opacity: 1,
        duration: 200,
        cursor: "pointer",
      });
    }
  }

  Navigate(direction) {
    // DOM Elements
    const progressBarWrapperDOM = document.getElementById(
      "configurator__progress-bar"
    );
    const stepDOM = document.getElementById("product-config__current-step");
    const activeScreenPosition = this.configuration.indexOf(this.activeScreen);
    let newIndexPostion = 0;

    switch (direction) {
      case "back":
        newIndexPostion = activeScreenPosition - 1;
        break;
      case "next":
        newIndexPostion = activeScreenPosition + 1;
        if (newIndexPostion === this.configuration.length) {
          return;
        }
        break;
    }

    if (newIndexPostion <= 0) {
      newIndexPostion = 0;
    }

    if (newIndexPostion !== activeScreenPosition) {
      this.activeScreen = this.configuration[newIndexPostion];
      this.BuildActiveScreen();
    }
  }

  BuildConfigurationLevel(configurations, type, level, parentUUID = null) {
    if (configurations && configurations.length > 0) {
      configurations.forEach((config) => {
        const { isConfiguration, children, name, uuid, isIndependentSwatch } =
          config;

        if (isConfiguration) {
          const currentLevel = level + 1;
          this.BuildConfigurationLevel(children, name, currentLevel, uuid);
        }

        this.BuildSwatch(config, type, level, parentUUID, isIndependentSwatch);
        this.AddSwatchFunctionality(config, type, level);
      });

      // TODO: Remove when another categories are available
      this.ModifyConfigurationLevel(type);
    }

    function applyDropShadow(element) {
      const level = element.id == "configurator__swatches__first-level" ? 1 : 2;
      const secondLevelHasContent =
        document.getElementById("configurator__swatches__second-level").children
          .length > 0;
      const firstLevelHasMandalas =
        document.getElementById("configurator__swatches__first-level")
          .children[0] &&
        document.getElementById("configurator__swatches__first-level")
          .children[0].innerHTML == "Mandalas";

      if (level == 1) {
        if (secondLevelHasContent && !firstLevelHasMandalas) {
          element.classList.add("drop-shadow-top-level");
        } else {
          element.classList.add("drop-shadow-single-level");
        }
      } else {
        element.classList.add("drop-shadow-bottom-level");
      }
    }
    const configUuid = configurations[0].id;

    const firstSwatch = document.getElementById(
      `contigurator_swatch_` + configUuid
    );

    switch (type) {
      case "1 Color":
      case "2 Color":
      case "3 Color":
      case "5 Color":
      case "7 Colors":
      case "Surface Color":
      case "Mandalas":
        if (firstSwatch && configurations.length > 5) {
          applyDropShadow(
            document.getElementById(`contigurator_swatch_` + configUuid)
              .parentElement
          );
        }
        break;

      case "MANTRA & AFFIRMATIONS":
      case "Reverse Point":
      case "End to End points":
      case "Top It Off":
      case "Text":
        if (firstSwatch && configurations.length > 2) {
          applyDropShadow(
            document.getElementById(`contigurator_swatch_` + configUuid)
              .parentElement
          );
        }
        break;

      case "Theme Category":
        if (firstSwatch && configurations.length > 0) {
          applyDropShadow(
            document.getElementById(`contigurator_swatch_` + configUuid)
              .parentElement
          );
        }
        break;

      case "Font and Colour":
        const swatches =
          document.getElementsByClassName(`configurator__swatch`);
        if (swatches && swatches.length > 0) {
          const fontSwatches = Array.from(swatches).filter((swatch) => {
            return swatch.classList.contains(
              "configurator__swatches__button-swatch"
            );
          });
          const colourSwatches = Array.from(swatches).filter((swatch) => {
            return swatch.classList.contains("configurator__swatch__icon");
          });

          if (fontSwatches && fontSwatches.length > 3) {
            applyDropShadow(
              document.getElementById(fontSwatches[0].id).parentElement
            );
          }

          if (colourSwatches && colourSwatches.length > 5) {
            applyDropShadow(
              document.getElementById(colourSwatches[0].id).parentElement
            );
          }
        }
        break;

      case "Line Design & Colours":
      default:
      //noop
    }
  }

  ModifyConfigurationLevel(type) {
    if (type === "Theme Category") {
      this.firstLevelWrapper.classList.add(
        "configurator__swatches__level--hidden"
      );
    } else {
      this.firstLevelWrapper.classList.remove(
        "configurator__swatches__level--hidden"
      );
    }
  }

  BuildSwatch(configuration, type, level, parentUUID, isIndependentSwatch) {
    // Don't build swatches bellow level 1 if the parent is not selected
    if (level > 1 && parentUUID) {
      const parentProperty = this.MapParentProperties(type);
      const parentPropertyValue = this.selectedElements[parentProperty];
      const parentPropertySelected = parentPropertyValue === parentUUID;
      if (!parentPropertySelected) {
        return;
      }
    }

    const getTypeName = () => {
      switch (type) {
        case "Font and Colour":
          return isIndependentSwatch ? "Font Colour" : "Font and Colour";
        default:
          return type;
      }
    };
    const typeName = getTypeName();

    switch (typeName) {
      case "Theme Category":

      case "Reverse Point":

      case "Top It Off":

      case "Text":
      case "MANTRA & AFFIRMATIONS":

      case "Font and Colour":
        this.BuildButtonSwatch(configuration, level, typeName);
        break;

      case "Environmentalism":
      case "Mysticism":
      case "Mandalas":
      case "Animals":
      case "Astrology/Zodiac Star Signs":

      case "Line Design & Colours":

      case "1 Color":
      case "2 Color":
      case "3 Color":
      case "5 Color":
      case "7 Colors":

      case "45 Degree Lines":
      case "Font Colour":
        this.BuildIconSwatch(configuration, level, typeName);
        break;

      case "Surface Color":
        this.BuildColorSwatch(configuration, level, typeName);

        break;

      case "End to End points":
        this.BuildTextSwatch(configuration, level, typeName);
        break;

      case "Liforme X You":
      case "FREE TEXT":
        this.BuildInputSwatch(configuration, level, typeName);
        break;

      default:
        break;
    }
  }

  AddSwatchFunctionality(configuration, type, level) {
    const { uuid, isConfiguration, name } = configuration;
    const element = document.getElementById(`contigurator_swatch_${uuid}`);

    if (element) {
      const elementDataset = element.dataset;
      const { type: elementType } = elementDataset;
      const currentProperty = this.MapSelectedProperties(type);

      if (elementType === "button") {
        element.addEventListener("click", () => {
          const currentPropertyValue = this.selectedElements[currentProperty];
          if (currentProperty && currentPropertyValue !== uuid) {
            const newProperties = {
              ...this.selectedElements,
              [currentProperty]: uuid,
            };

            this.selectedElements = newProperties;

            // Remove active swatch class
            const activeSwatch = document.querySelectorAll(
              `.configurator__swatch--active`
            );

            if (activeSwatch && activeSwatch.length > 0) {
              activeSwatch.forEach((swatch) => {
                const swatchDataset = swatch.dataset;
                if (swatchDataset.level === String(level)) {
                  swatch.classList.remove("configurator__swatch--active");
                }
              });
            }

            // Remove text from input on step 8 when swapping text options
            if (type == "Text") {
              this.selectedElements.textSelection = "";
              if (element.innerHTML == "Liforme X You") {
                this.selectedElements.fontAndColour = "liformeFont";
              }
            }

            // Add active swatch class
            element.classList.add("configurator__swatch--active");

            // Only update no configuration swatches
            if (isConfiguration) {
              this.BuildActiveScreen();
            } else {
              this.UpdateVisualizer(this.activeScreen, configuration);
              this.BuildActiveScreen();
            }

            // Set search parameter
            this.SetQueryParameters(currentProperty, uuid);

            setTimeout(function () {
              // If changing number of lines then select first available color by default
              const firstAvailableSecondLevelOption = document.getElementById(
                "configurator__swatches__second-level"
              ).children[0];

              if (
                firstAvailableSecondLevelOption &&
                element.getAttribute("data-level") == 1
              ) {
                firstAvailableSecondLevelOption.click();
              }
            }, 100);
          }
        });
      }

      if (elementType === "input") {
        const currentValue = this.selectedElements.textSelection;
        const currentText =
          type === "Liforme X You" ? `LIFORME X ${currentValue}` : currentValue;
        const fontConfigurations = this.GetFontConfigurations(
          this.selectedElements.fontAndColour
        );
        const fontColour = this.GetFontColor(this.selectedElements.fontColour);

        this.UpdateVisualizer(this.activeScreen, configuration);
        this.UpdateTextNode(currentText);
        this.UpdateTextNodeAttributes({
          ...fontConfigurations,
          color: fontColour,
        });

        const newProperties = {
          ...this.selectedElements,
          [currentProperty]: uuid,
        };

        // Update state
        this.selectedElements = newProperties;

        // Set search parameter
        this.SetQueryParameters(currentProperty, uuid);

        element.addEventListener("input", (e) => {
          e.preventDefault();
          const text = e.target.value.replace(/[^a-zA-Z0-9 \b]/g, "");

          // Additional Text
          const modifiedText = this.GetModifiedText(text);

          const newProperties = {
            ...this.selectedElements,
            textSelection: text,
          };

          // Update state
          this.selectedElements = newProperties;

          // Update text node
          this.UpdateTextNode(modifiedText);

          // Set search parameter
          this.SetQueryParameters("textSelection", text);
        });
      }

      if (elementType === "preselectedText") {
        element.addEventListener("click", () => {
          const fontConfigurations = this.GetFontConfigurations(
            this.selectedElements.fontAndColour
          );
          const fontColour = this.GetFontColor(
            this.selectedElements.fontColour
          );

          const freeTextConfiguration = this.configuration
            .filter((config) => config.name === "Text")[0]
            .children.filter((child) => child.name === "FREE TEXT")[0]
            .children[0];

          // Update visualizer
          this.UpdateVisualizer(this.activeScreen, freeTextConfiguration);
          this.UpdateTextNode(name);
          this.UpdateTextNodeAttributes({
            ...fontConfigurations,
            color: fontColour,
          });

          // Update state
          const newProperties = {
            ...this.selectedElements,
            [currentProperty]: uuid,
            textSelection: name,
          };

          this.selectedElements = newProperties;

          // Set search parameter
          this.SetQueryParameters(currentProperty, uuid);

          // Update UI
          this.BuildActiveScreen();
        });
      }

      if (elementType === "fontColour") {
        element.addEventListener("click", () => {
          const newProperties = {
            ...this.selectedElements,
            fontColour: uuid,
          };
          const fontColour = this.GetFontColor(uuid);
          const fontConfigurations = this.GetFontConfigurations(
            this.selectedElements.fontAndColour
          );
          // Update state
          this.selectedElements = newProperties;

          // Update text node and attributes
          if (fontColour) {
            this.UpdateTextNodeAttributes({
              ...fontConfigurations,
              color: fontColour,
            });
            const modifiedText = this.GetModifiedText(
              this.selectedElements.textSelection
            );
            this.UpdateTextNode(modifiedText);
          }

          // Update UI
          this.BuildActiveScreen();

          // Set search parameter
          this.SetQueryParameters("fontColour", uuid);
        });
      }

      if (elementType === "fontFamily") {
        element.addEventListener("click", () => {
          const newProperties = {
            ...this.selectedElements,
            [currentProperty]: uuid,
          };
          const fontConfigurations = this.GetFontConfigurations(uuid);
          const fontColour = this.GetFontColor(
            this.selectedElements.fontColour
          );

          // Update state
          this.selectedElements = newProperties;

          // Update text node and attributes
          if (fontConfigurations) {
            this.UpdateTextNodeAttributes({
              ...fontConfigurations,
              color: fontColour,
            });
            const modifiedText = this.GetModifiedText(
              this.selectedElements.textSelection
            );
            this.UpdateTextNode(modifiedText);
          }

          // Update UI
          this.BuildActiveScreen();

          // Set search parameter
          this.SetQueryParameters(currentProperty, uuid);
        });
      }
    }
  }

  UpdateTextNode(text) {
    // DOM elements
    const input = document.querySelector(".configurator__swatch__input");

    // Check what's the current font selected
    const currentFont = this.selectedElements.fontAndColour;
    const formatText = () => {
      switch (currentFont) {
        case "liformeFont":
          const upperCaseText = text.toUpperCase();
          return upperCaseText;

        default:
          return text;
      }
    };

    const includesBlackListedWord = (textToTest) => {
      const blackListedWords = localStorage.getItem("blacklisted-words");
      const parsedBlackListedWords = JSON.parse(blackListedWords);
      const filteredBlackListedWords = parsedBlackListedWords.filter(
        (badWord) => textToTest.toLowerCase().trim().includes(badWord)
      );
      const hasBlackListedWords =
        filteredBlackListedWords.length > 0 ? true : false;
      return hasBlackListedWords;
    };

    const formattedText = formatText();
    const blackListedWordIncluded = includesBlackListedWord(formattedText);

    // Check if the string contains a blacklisted word
    if (blackListedWordIncluded) {
      // Trigger the error
      if (input) {
        input.setCustomValidity("Bad word found!");
        input.reportValidity();
      }

      return;
    } else {
      const placeholder = input ? input.getAttribute("placeholder") : null;

      var maxCharacters;
      switch (placeholder) {
        case "Enter Your Name":
          // 'LIFORME X ' is 10 characters, plus 8 characters for name input
          maxCharacters = 10 + 8;
          break;
        case "Type whatever you want":
          maxCharacters = 21;
          break;
        default:
          maxCharacters = 22;
      }

      const characterLimitString = formattedText.substring(0, maxCharacters);
      const textWithSpacing = `                                                                                       ${characterLimitString}`;
      this.api.scene.updateTextNode(textWithSpacing);
    }
  }

  UpdateTextNodeAttributes(additionalAttributes) {
    const baseAttributes = {
      textAlign: "center",
      maxWidth: 0.6,
      fontSize: 0.04,
    };

    const attributes = {
      ...baseAttributes,
      ...additionalAttributes,
    };

    this.api.scene.updateTextNodeAttributes(attributes);
  }

  UpdateVisualizer(parentConfiguration, childConfiguration) {
    this.api.configurator.setConfigurationValue(
      parentConfiguration,
      childConfiguration
    );
  }

  MapSelectedProperties(type) {
    switch (type) {
      case "Surface Color":
        return "surfaceColor";

      case "End to End points":
        return "endToEndLines";

      case "45 Degree Lines":
        return "sideBars";

      case "Reverse Point":
        return "reversePoints";

      case "Top It Off":
        return "topItOff";

      case "Line Design & Colours":
        return "lineDesignAndColors";
      case "1 Color":
      case "2 Color":
      case "3 Color":
      case "5 Color":
      case "7 Colors":
        return "lineDesignAndColorsSelection";

      case "Theme Category":
        return "theme";
      case "Environmentalism":
      case "Mysticism":
      case "Mandalas":
      case "Animals":
      case "Astrology/Zodiac Star Signs":
        return "themeSelection";

      case "Text":
        return "text";

      case "Liforme X You":
      case "MANTRA & AFFIRMATIONS":
      case "FREE TEXT":
        return "textOptionSelection";

      case "Font and Colour":
        return "fontAndColour";

      case "Font Colour":
        return "fontColour";

      default:
        return "";
    }
  }

  MapParentProperties(type) {
    switch (type) {
      case "Environmentalism":
      case "Mysticism":
      case "Mandalas":
      case "Animals":
      case "Astrology/Zodiac Star Signs":
        return "theme";

      case "1 Color":
      case "2 Color":
      case "3 Color":
      case "5 Color":
      case "7 Colors":
        return "lineDesignAndColors";

      case "Liforme X You":
      case "MANTRA & AFFIRMATIONS":
      case "FREE TEXT":
        return "text";

      default:
        return "";
    }
  }

  BuildInputSwatch(configuration, level, type) {
    const { uuid } = configuration;
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];

    const getInputConfiguration = () => {
      switch (type) {
        case "Liforme X You":
          return {
            placeholder: "Enter Your Name",
          };

        default:
          return {
            placeholder: "Type whatever you want",
          };
      }
    };

    const { placeholder } = getInputConfiguration();

    var maxCharacters = "";
    switch (placeholder) {
      case "Enter Your Name":
        maxCharacters = "(Max 8 Characters)";
        break;
      default:
        maxCharacters = "(Max 20 Characters)";
    }

    const htmlStructure = `
    <div id="contigurator_swatch_${uuid}" data-level="${level}" data-type="input" class="configurator__swatch configurator__swatches__input-swatch">
      <div class="configurator__swatches__input-swatch__wrapper">
		<input type placeholder="${placeholder}" value="" class="configurator__swatch__input" maxlength="${maxCharacters.replace(
      /\D/g,
      ""
    )}" />

		<label>${maxCharacters}</label>
      </div>
    </div>
    `;

    this.AppendSwatchToLevel(htmlStructure, level);
  }

  BuildIconSwatch(configuration, level, type) {
    const { name, label, uuid, isConfiguration } = configuration;
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const isSwatchActive = currentPropertyValue === uuid;
    const iconLabel = label || name;
    const getCurrentLevel = () => {
      switch (type) {
        case "Font Colour":
          return 2;
        default:
          return level;
      }
    };
    const getSwatchType = () => {
      switch (type) {
        case "Font Colour":
          return "fontColour";

        default:
          return "button";
      }
    };

    const getAdditionalLabel = () => {
      if (type === "Line Design & Colours" && name === "7 Colors") {
        let costPrice = 1000;
        if (window.customMatAdditionalCosts["7_colour"]) {
          costPrice = window.customMatAdditionalCosts["7_colour"];
        }
        const price = Shopify.formatMoney(costPrice, theme.moneyFormat);
        return `+${price}`;
      }

      if (type === "Line Design & Colours" && name === "5 Color") {
        let costPrice = 500;
        if (window.customMatAdditionalCosts["5_colour"]) {
          costPrice = window.customMatAdditionalCosts["5_colour"];
        }
        const price = Shopify.formatMoney(costPrice, theme.moneyFormat);
        return `+${price}`;
      }

      if (type === "Line Design & Colours" && name === "3 Color") {
        let costPrice = 500;
        if (window.customMatAdditionalCosts["3_colour"]) {
          costPrice = window.customMatAdditionalCosts["3_colour"];
        }
        const price = Shopify.formatMoney(costPrice, theme.moneyFormat);
        return `+${price}`;
      }

      return "";
    };

    const currentLevel = getCurrentLevel();
    const swatchType = getSwatchType();
    const getSwatchSizeClass = () => {
      // TODO: Remove this validation when more configurations are added
      if (currentLevel > 1 && type !== "Mandalas") {
        return "configurator__swatch__icon--sm";
      }
      if (!isConfiguration || type === "Mandalas") {
        return "configurator__swatch__icon--lg";
      }
      return "";
    };
    const swatchSizeClass = getSwatchSizeClass();
    const swatchActiveClass = isSwatchActive
      ? "configurator__swatch--active"
      : "";
    const labelBehaviour = isSwatchActive
      ? "configurator__swatches__label--thin"
      : "configurator__swatches__label--hidden";

    const getSVGUrl = () => {
      switch (type) {
        // Line Design & Colours

        case "Line Design & Colours": {
          switch (name) {
            case "1 Color":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_1_active.svg?v=1634852215"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_1.svg?v=1634852215";
            case "2 Color":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_2_active.svg?v=1634852215"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_2.svg?v=1634852215";
            case "3 Color":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_3_active.svg?v=1634852215"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_3.svg?v=1634852215";
            case "5 Color":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_5_active.svg?v=1634852215"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_5.svg?v=1634852215";
            case "7 Colors":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_7_active.svg?v=1634852215"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/color_7.svg?v=1634852215";
          }
        }
        case "1 Color": {
          switch (name) {
            case "Rose":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Rose.svg?v=1698176202";
            case "Amethyst":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Amethyst.svg?v=1698176202";
            case "Lemon":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lemon.svg?v=1698176202";
            case "Teal":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Teal.svg?v=1698176202";
            case "Sage":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Sage.svg?v=1698176202";
            case "Apricot":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Apricot.svg?v=1698176202";
            case "Midnight":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Midnight.svg?v=1698176202";
            case "Linen":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Linesn.svg?v=1698176202";
            case "Orange":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_orange.svg?v=1635208505";
            case "Yellow":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_yellow.svg?v=1635208505";
            case "Lime":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_lime.svg?v=1635208505";
            case "Dark Green":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_dark-green.svg?v=1635208505";
            case "Blue":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_blue.svg?v=1635208505";
            case "Majestic Blue":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_royal-blue.svg?v=1635208505";
            case "Lilac":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_lilac.svg?v=1635208505";
            case "Hot Pink":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_hot-pink.svg?v=1635208505";
            case "Purple":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_purple.svg?v=1635208505";
            case "Dark Purple":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_dark-purple.svg?v=1635208505";
            case "Gold":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_gold.svg?v=1635208505";
          }
        }

        case "2 Color": {
          switch (name) {
            case "Blossom":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Blossom.svg?v=1698176575";
            case "Lilac":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lilac.svg?v=1698176586";
            case "Citrus":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Citrus.svg?v=1698176575";
            case "Aqua":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Aqua.svg?v=1698176575";
            case "Sorbet":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Sorbet.svg?v=1698176586";
            case "Charcoal":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Charcoal.svg?v=1698176575";
            case "Moss":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Moss.svg?v=1698176587";
            case "Summer Fun":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Summer_Fun_-_2.svg?v=1636466957";
            case "Sunset":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Sunset_-_2_colours.svg?v=1636466958";
            case "Ocean":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Ocean.svg?v=1636466957";
            case "Hibiscus":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/2_hot-pink_soft-orange.svg?v=1635209031";
            case "Earth":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Earth-2.svg?v=1636466957";
            case "Summer":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/2_soft-orange_blue.svg?v=1635209031";
            case "Sun & Ocean":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/2_yellow_blue.svg?v=1635209031";
            case "Meadow":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/2_lilac_turquoise.svg?v=1635209031";
            case "Pinks":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/2_maroon_pink.svg?v=1635209031";
            case "Midnight":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/2_tbd.svg?v=1635209031";
          }
        }

        case "3 Color": {
          switch (name) {
            case "Blush":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Blush.svg?v=1698176651";
            case "Slate":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Slate.svg?v=1698176651";
            case "Stone":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Stone.svg?v=1698176586";
            case "Plum":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Plum.svg?v=1698176651";
            case "Mustard":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mustard.svg?v=1698176651";
            case "Marine":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Marine.svg?v=1698176651";
            case "Rouge":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Rouge.svg?v=1698176652";
            case "Taupe":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Taupe.svg?v=1698176651";
            case "Slate":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Slate.svg?v=1698176651";
            case "Pine":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Pine.svg?v=1698176651";
            case "Fire":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/3_red_orange_yellow.svg?v=1635209365";
            case "Earth":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Earth.svg?v=1636467629";
            case "Ancient Ocean":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Ancient-Ocean.svg?v=1636467005";
            case "Summer Fun":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Summer-Fun.svg?v=1636467005";
          }
        }

        case "5 Color": {
          switch (name) {
            case "Rainbow Sky":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Rainbow_Sky.svg?v=1692117613";
            case "Skylight":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Skylight.svg?v=1698176794";
            case "Lavender":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lavender.svg?v=1698176795";
            case "Peonies":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Peonies.svg?v=1698176794";
            case "Vanilla":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Vanilla.svg?v=1698176795";
            case "Granite":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Granite.svg?v=1698176794";
            case "Sand":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Sand.svg?v=1698176794";
            case "Creme":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Creme.svg?v=1698176794";
            case "Olive Tree":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Olive_Tree.svg?v=1698176977";
            case "Lively Lolly":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Lively-Lolly.svg?v=1636469315";
          }
        }

        case "7 Colors": {
          switch (name) {
            case "Rainbow":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Rainbow-7.svg";
            case "Storm":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Storm.svg?v=1698177009";
            case "Forest":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Forest.svg?v=1698177009";
            case "Skies":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Skies.svg?v=1698177009";
            case "Sunrise":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Sunrise.svg?v=1698177010";
            case "Summer Glow":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Saummer_Glow.svg?v=1698177009";
            case "Carnations":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Carnations.svg?v=1698177009";
            case "Ceramics":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Ceramics.svg?v=1698177009g";
            case "Twilight":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Twilight.svg?v=1698177009";
            case "Neutrals":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Neturals.svg?v=1698177009";
            case "Sunset":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Sunset_-_7.svg";
          }
        }

        // Side Bars
        case "45 Degree Lines": {
          switch (name) {
            case "Straight":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/straight_side_bars.svg?v=1634694423"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/straight_side_bars_inactive.svg?v=1635221372";
            case "Curved":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/curved_side_bars.svg?v=1634694423"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/curved_side_bars_inactive.svg?v=1635221415";
            case "None":
              return isSwatchActive
                ? "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/no_side_bars.svg?v=1634694423"
                : "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/no_side_bars_inactive.svg?v=1635221372";
          }
        }

        // Theme
        case "Mandalas": {
          switch (name) {
            case "Classic":
              return "https://cdn.shopify.com/s/files/1/0244/0983/3553/files/Mandala-Classic.png";
            case "Cosmic Moon":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Frame_655.png?v=1701685691";
            case "Mindful Garden":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Mindful_Garden.png?v=1701277353";
            case "Paisley":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Paisley_7ef8a9b6-76fe-4e7c-ad1e-964550f5cf0e.png?v=1701343946";
            case "Cube":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Cube_480d0e8d-eabb-49fc-9bc7-4a0079c55243.png?v=1701343946";
            case "Planet Earth":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Planet_Earth_de6e3c9e-8c3c-470f-a093-7dab2255186f.png?v=1701343946";
            case "Geometric":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Geometric_3cfb1377-db27-4182-b1c0-8d6226ec0fbc.png?v=1701343946";
            case "Simple Curved":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Simple_Curved_icon_2.png?v=1701343946";
            case "Simple Straight":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Mandala-Simple_Straight_3f2ea0f6-08fa-467b-815d-8f91549fb074.png?v=1701343946";
            case "Love":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Group_165_16886a85-1d52-44c6-9ef6-2292ef4d2571.png?v=1701343946";
          }
        }

        // Font color
        case "Font Colour": {
          switch (name) {
            case "Skylight":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Skylight_5d15d11b-1e79-43d7-a946-61d976bc8578.svg?v=1701344229";
            case "Rose":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Rose_a54b166f-c24c-4aa7-924c-4d37201565c1.svg?v=1701344229";
            case "Moss":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Moss_0b8d8e9f-f1c6-4720-8296-d6210364349f.svg?v=1701344228";
            case "Charcoal":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Charcoal_7954a592-cb24-4177-b4e6-9adad992a837.svg?v=1701344229";
            case "Amethyst":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Amythest.svg?v=1701344229";
            case "Taupe":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Taupe_8307548e-5dd5-433d-81c0-8aaf781d2fd2.svg?v=1701344229";
            case "Lemon":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Lemon_948693fb-b611-4d0c-b0b2-0d2535981f6b.svg?v=1701344229";
            case "Sorbet":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Sorbet_ca1e4767-f7ca-40d1-b7f0-b98cd44f382e.svg?v=1701344229";
            case "Sand":
              return "https://cdn.shopify.com/s/files/1/0259/3665/8531/files/Sand_a7dd82e7-e934-4025-b82d-d583929b02b1.svg?v=1701344229";
            case "Red":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_red.svg?v=1635208505";
            case "Orange":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_orange.svg?v=1635208505";
            case "Yellow":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_yellow.svg?v=1635208505";
            case "Green":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_dark-green.svg?v=1635208505";
            case "Blue":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_blue.svg?v=1635208505";
            case "Dark Blue":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_royal-blue.svg?v=1635208505";
            case "Purple":
              return "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/1_purple.svg?v=1635208505";
          }
        }

        case "Ocean":
        case "Trees":

        case "Sun":
        case "Moon":
        case "Stars":

        case "Snowflake":

        case "Butterfly":
        case "Lion":
        case "Cobra":

        case "Aries":
        case "Taurus":
        case "Gemini":
        case "Cancer":
        case "Leo":
        case "Virgo":
        case "Libra":
        case "Scorpio":
        case "Sagittarius":
        case "Capricorn":
        case "Aquarius":
        case "Pisces":

        default:
          break;
      }
    };

    const additionalLabel = getAdditionalLabel();
    const currentIcon = getSVGUrl();

    const htmlStructure = `
	  <button id="contigurator_swatch_${uuid}" data-level="${currentLevel}" data-type="${swatchType}" class="configurator__swatch configurator__swatch__icon ${swatchSizeClass} ${swatchActiveClass}">
        <div class="configurator__swatch__icon__wrapper">
          <img src="${currentIcon}" alt="${name} icon" />
        </div>
        <label class="configurator__swatches__label ${labelBehaviour}">${iconLabel}${
      additionalLabel
        ? `<p class="configurator__swatches__label__additional">${additionalLabel}</p>`
        : ""
    }</label>
		
      </button>
      `;

    this.AppendSwatchToLevel(htmlStructure, currentLevel);
  }

  BuildButtonSwatch(configuration, level, type) {
    const { name, uuid } = configuration;
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const swatchActiveClass =
      currentPropertyValue === uuid ? "configurator__swatch--active" : "";
    const getSwatchType = () => {
      switch (type) {
        case "Font and Colour":
          return "fontFamily";

        case "MANTRA & AFFIRMATIONS":
          return "preselectedText";

        default:
          return "button";
      }
    };
    const swatchType = getSwatchType();
    const textType = this.selectedElements.textOptionSelection;

    if (swatchType === "fontFamily") {
      let fontClass = "";
      switch (name) {
        case "Simple":
          fontClass = "simple-font";
          break;
        case "Rounded":
          fontClass = "rounded-font";
          break;
        case "Handwritten":
          fontClass = "handwritten-font";
          break;
      }
      if (textType === "133521a0-53de-013c-7fc6-62df975635cc") {
        var htmlStructure = "";
        if (uuid === "liformeFont") {
          htmlStructure = `
                        <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${swatchActiveClass}">${name}</button>
                        <div class="liforme-font-notification">This text option is only available in Liforme font</div>
                    `;
        } else {
          htmlStructure = `
                        <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${fontClass} disabled">${name}</button>
                    `;
        }

        this.AppendSwatchToLevel(htmlStructure, level);
      } else {
        const htmlStructure = `
                    <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${fontClass} ${swatchActiveClass}">${name}</button>
                `;

        this.AppendSwatchToLevel(htmlStructure, level);
      }
    } else {
      const htmlStructure = `
                <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type=${swatchType} class="configurator__swatch configurator__swatches__button-swatch ${swatchActiveClass}">${name}</button>
            `;

      this.AppendSwatchToLevel(htmlStructure, level);
    }
  }

  BuildTextSwatch(configuration, level, type) {
    const { name, uuid, isConfiguration } = configuration;
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const getSwatchSizeClass = () => {
      if (level > 1) {
        return "configurator__swatch__icon--sm";
      }
      if (!isConfiguration) {
        return "configurator__swatch__icon--lg";
      }
      return "";
    };
    const swatchSizeClass = getSwatchSizeClass();
    const swatchActiveClass =
      currentPropertyValue === uuid ? "configurator__swatch--active" : "";

    const htmlStructure = `
    <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type="button" class="configurator__swatch configurator__swatch__icon configurator__swatch__icon--only-text ${swatchSizeClass} ${swatchActiveClass}">
      <div class="configurator__swatch__icon__wrapper">
        <div>
          <span>${name}</span>
        </div>
      </div>
    </button>
    `;

    this.AppendSwatchToLevel(htmlStructure, level);
  }

  BuildColorSwatch(configuration, level, type) {
    const { name, uuid, isConfiguration } = configuration;
    const getCurrentColorClass = () => {
      switch (name) {
        case "Blue":
          return "blue";
        case "Dusk Blue":
          return "dusk";
        case "Olive":
          return "olive";
          case "Aqua Teal":
          return "aqua";
        case "Red":
          return "red";
        case "Black":
          return "black";
           case "Forest Green":
          return "forest";
        case "Maroon":
          return "maroon";
        case "White":
          return "white";
        case "Golden Sand":
          return "sand";
        case "Pink":
          return "pink";
        case "Grey":
          return "grey";
        case "Orange":
          return "orange";
        case "Purple Earth":
          return "purple";
        case "Yellow":
          return "yellow";
        default:
          return "";
      }
    };

    const currentColorClass = getCurrentColorClass();
    const currentProperty = this.MapSelectedProperties(type);
    const currentPropertyValue = this.selectedElements[currentProperty];
    const swatchActiveClass =
      currentPropertyValue === uuid ? "configurator__swatch--active" : "";
    const getSwatchSizeClass = () => {
      if (level > 1) {
        return "configurator__swatch__icon--sm";
      }
      if (!isConfiguration) {
        return "configurator__swatch__icon--lg";
      }
      return "";
    };

    const swatchSizeClass = getSwatchSizeClass();

    const htmlStructure = `
    <button id="contigurator_swatch_${uuid}" data-level="${level}" data-type="button" class="configurator__swatch configurator__swatch__icon configurator__swatch__icon--hide-inactive ${swatchSizeClass} ${swatchActiveClass}">
      <div class="configurator__swatch__icon__wrapper">
        <svg class="configurator__swatches__color-swatch__color configurator__swatches__color-swatch--${currentColorClass}" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="50"/>
        </svg>
      </div>
      <label class="configurator__swatches__label">${name}</label>
    </div>
    `;

    this.AppendSwatchToLevel(htmlStructure, level);
  }

  AppendSwatchToLevel(swatch, level) {
    let levelWrapper = null;
    if (level === 1) {
      levelWrapper = this.firstLevelWrapper;
    } else if (level === 2) {
      levelWrapper = this.secondLevelWrapper;
    }

    if (levelWrapper) {
      levelWrapper.insertAdjacentHTML("beforeend", swatch);
    }
  }

  GetFontConfigurations(uuid) {
    switch (uuid) {
      case "liformeFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/The_Liforme_Typeface.otf?v=1635376453",
          fontSize: 0.05,
          anchorY: -0.025,
          letterSpacing: -0.05,
        };
      case "simpleFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/Urbane_Rouned_-_Medium.otf?v=1635376453",
          fontSize: 0.035,
          anchorY: 0.003,
        };
      case "roundedFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/Chennai.otf?v=1635376453",
          fontSize: 0.04,
          anchorY: 0.008,
          letterSpacing: 0.01,
        };
      case "handwrittenFont":
        return {
          font: "https://cdn.shopify.com/s/files/1/0548/9645/9869/files/Mister_Brown.otf?v=1635376453",
          fontSize: 0.055,
          anchorY: -0.01,
        };
    }
  }

  GetFontColor(uuid) {
    switch (uuid) {
     case "rose":
        return "#CB3535";
      case "moss":
        return "#1A310A";
      case "sorbet":
        return "#A81502";
      case "charcoal":
        return "#050404";
      case "skylight":
        return "#75CCE2";
      case "taupe":
        return "#897153";
      case "amethyst":
        return "#562358";
      case "lemon":
        return "#CB9F0A";
      case "sand":
        return "#A99280";
      case "red":
        return "#CE0101";
      case "orange":
        return "#D15F28";
      case "yellow":
        return "#EBAE13";
      case "green":
        return "#073012";
      case "blue":
        return "#045191";
      case "darkBlue":
        return "#091436";
      case "purple":
        return "#2A0A2E";
    }
  }

  GetModifiedText(text) {
    // TODO: Make this function dynamic
    const currentSelectedText = this.selectedElements.textOptionSelection;
    const modifyText = () => {
      switch (currentSelectedText) {
        case "133521a0-53de-013c-7fc6-62df975635cc":
          return `LIFORME X ${text}`;
        default:
          return text;
      }
    };

    const modifiedText = modifyText();
    return modifiedText;
  }
}

const Init = () => {
  const sayduckInit = (e) => {
    // Global variables
    const sayduckAPI = e.detail.instance;
    const configurator = new ProductConfigurator(sayduckAPI);

    // Global DOM Elements
    const closeButton = document.getElementById("product-config__close-button");
    const stayButton = document.getElementById("product-config__stay-button");
    const modalWrapper = document.getElementById("product-config__modal");
    const backButton = document.getElementById("product-config__back-button");
    const nextButton = document.getElementById("product-config__next-button");

    // Event handlers
    const handleCloseButton = () => {
      const isVisible = modalWrapper.classList.contains(
        "configurator__close-modal--visible"
      );
      if (!isVisible) {
        modalWrapper.classList.add("configurator__close-modal--visible");
        return;
      }
      modalWrapper.classList.remove("configurator__close-modal--visible");
    };

    const closeModal = (e) => {
      const target = e.target;
      const closestModal = target.closest(".configurator__modal");
      const closestTrigger = target.closest(".configurator__modal__trigger");

      if (!closestModal && !closestTrigger) {
        modalWrapper.classList.remove("configurator__close-modal--visible");
      }
    };

    const handleNavigation = (direction) => {
      configurator.Navigate(direction);
    };

    const dropShadowClasses = [
      "drop-shadow-top-level",
      "drop-shadow-single-level",
      "drop-shadow-bottom-level",
    ];
    const removeDropShadow = () => {
      dropShadowClasses.forEach((shadowClass) => {
        document
          .getElementById("configurator__swatches__first-level")
          .classList.remove(shadowClass);
        document
          .getElementById("configurator__swatches__second-level")
          .classList.remove(shadowClass);
      });
    };

    // Init
    configurator.InitializeConfigurator();

    // Init: Events
    document.addEventListener("click", closeModal);
    closeButton.addEventListener("click", handleCloseButton);
    stayButton.addEventListener("click", handleCloseButton);
    backButton.addEventListener("click", () => handleNavigation("back"));
    nextButton.addEventListener("click", () => handleNavigation("next"));
    backButton.addEventListener("mousedown", () => removeDropShadow());
    nextButton.addEventListener("mousedown", () => removeDropShadow());
  };

  // Init: Sayduck integration
  window.addEventListener("sayduck.api-ready", sayduckInit);
};

// Init: Global functionality
document.body.classList.add("configurator--hide-scroll");
document.addEventListener("DOMContentLoaded", Init);

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();
